define([
	'jquery',
    'modal-terms',
    'bootstrap'
], function(
	$,
    ModalTerms
) {

    /*
        Function -> recount cars bars and arrows
    */
    var carsBarAddArrows = function(){
        $('.tab-headers').each(function() {
            var parent = $(this);
            var childWidth = parent.find('.nav').width();
            if(parent.width() < childWidth){
                parent.css('padding', '0px 15px');
                parent.children('.cars-bar-next').addClass('display').css('right', 0);
                parent.children('.cars-bar-prev').css('left', 0);
                parent.css('width', '100%');
            } else {
                if($(window).width() < 768){
                    parent.children('.cars-bar-next').removeClass('display');
                    parent.css('width', childWidth + 30)
                }
            }
        });
    };

// Recount cars bars and arrows on resize
    $(window).on('resize', function(){
        carsBarAddArrows();
    });

    $(window).bind('orientationchange', function() {
        carsBarAddArrows();
    });

    /**
     * Scrolluje stronę do wyszukiwarki
     */
    var checkPrice = function() {
        $('.form-cars-search').show("fold", 800);
        $('html, body').animate({
            scrollTop: $(".search-header").offset().top
        }, 500);
    };

    /**
     * Wczytuje tab z treścią dla pojedynczego samochodu w grupie
     * @param $targetLink Link <a ..> który wywołał otwarcie taba z (taby bootstrapowe)
     * @param $previousLink Link <a ..> dla tabaktóry był poprzednio aktywny (taby bootstrapowe)
     */
    var loadTabCar = function($targetLink, $previousLink) {
        var $targetTab = $($targetLink.attr('href'));
        var $previousTab = $($previousLink.attr('href'));

        if($targetTab.length > 0) {
            $previousTab.hide();
            $targetTab.show();
            return; /* jeśli tab już istnieje, nie rób nic */
        }

        var tabId = $targetLink.attr('href').substring(1);
        $targetTab = $previousTab.clone();
        $targetTab.empty()
            .prop('id', tabId)
            .addClass('loading');

        $previousTab.parent().append($targetTab);

        var $tabContent = $previousTab.parent().closest('.tab-content');
        var requestUrl = $tabContent.data('url');
        var carId = $targetLink.data('car-id');

        var $previousPanel = $tabContent.find($previousLink.attr('href'));
        $previousPanel.hide();

        $.get(requestUrl, { carId: carId}, function(data, textStatus, xhr) {
            var $tabContent = $(data).children();

            $targetTab.html($tabContent);
            $targetTab.removeClass('loading');

            // lazy load dla nowych pozycji
            $targetTab.find('img.lazy-load').lazyload({
                effect : "fadeIn",
                event : "loadNow"
            }).trigger("loadNow");

            $targetTab.find('.iframe').click(function (e) {
                e.preventDefault();
                var src = this.href;
                var title = this.title || $(this).text();

                var options = {
                    title : title,
                };
                PS.ui.dialog.iframe(src, options);
            });

            $targetTab.find('.btn.check-price').click(checkPrice);
        });
    };

    $(document).ready(function() {

        carsBarAddArrows();

        $(document).on('click', 'ul.nav li', function(){
            var $nav = $(this).parent();
            var $parent = $nav.parent();
            var parentLeft = $parent.offset().left;
            var parentRight = $parent.offset().left + $parent.width();
            var liLeft = $(this).offset().left;

            // switch tab
            var $previousTab = $nav.find('.active');
            var $targetTab = $(this);

            $previousTab.removeClass('active');
            $targetTab.addClass('active');

            // check tab is fully visible
            if(liLeft < parentLeft){
                navigateCarsBar($nav, parentLeft + 15 - liLeft, {direction:"Left"});
            }
            if(liLeft+$(this).width()>parentRight){
                navigateCarsBar($nav,  $(this).width() + (liLeft - parentRight) + 15, {direction:"Right"});
                $parent.children('.cars-bar-prev').addClass('display');
            }
        });

        $('a[data-toggle="tab"]').click(function(e) {
            e.preventDefault();
            var $nav = $(this).parent().parent();
            var $previousTab = $nav.find('.active');
            var $targetTab = $(this).parent();

            // load new content
            var $targetLink = $targetTab.find('a[data-toggle="tab"]');
            var $previousLink = $previousTab.find('a[data-toggle="tab"]');
            loadTabCar($targetLink, $previousLink);
        });

        /*
                    CarsBar Tabs Carousel dla spuczonych wyników wyszukiwania
                */
        $(document).on('click', '.cars-bar', function(e){
            e.preventDefault();
            var $nav = $(this).parent().children('.nav');
            var $parent = $(this).parent();
            var data = {
                direction : 'Right',
                rightArrow : $(this),
                leftArrow : $(this).parent().find('.cars-bar-prev'),
                tabWidth: 128,
                time : 100,

                widthDiff: $nav.width() - $parent.width(),
                rest: parseInt($nav.offset().left)-(parseInt($parent.offset().left)+15)
            };

            // Switch direction if needed
            if($(this).hasClass('cars-bar-prev')){
                data.direction = 'Left';
                data.leftArrow = $(this);
                data.rightArrow = $(this).parent().find('.cars-bar-next');
            }

            // Check Margin
            checkMarginCarsBar(data, function(animateFactor) {
                // Animate Bar and display arrows
                navigateCarsBar($nav, animateFactor, data);
            });
        });


        var checkMarginCarsBar = function(data, callback){
            var diff = data.rest+data.widthDiff;

            if(data.direction=='Right'){
                if(diff > data.tabWidth) {
                    data.leftArrow.addClass('display');
                    callback(data.tabWidth);
                } else {
                    data.rightArrow.removeClass('display');
                    data.leftArrow.addClass('display');
                    callback(diff);
                }
            } else {
                if(data.rest < -data.tabWidth){
                    data.rightArrow.addClass('display');
                    callback(data.tabWidth);
                } else {
                    data.leftArrow.removeClass('display');
                    data.rightArrow.addClass('display');
                    callback(-(data.rest));
                }
            }
        };

        var navigateCarsBar = function($obj, animateFactor, data){
            if(animateFactor != 0){
                if(data.time==undefined){
                    data.time = 200;
                }
                if(data.direction == 'Right'){
                    data.direction = {left: '-='+animateFactor};
                } else {
                    data.direction = {left: '+='+animateFactor}
                }

                $obj.stop(true,true).animate(data.direction, data.time);
                $obj.find('img.lazy-load').trigger('scroll'); // scroll event dla lazy-load
            }
        };

        $('.change-search-options').click(function(e) {
            e.preventDefault();
            $('.form-cars-search').show();
        });

        $('#form-car-search-change-button').click(function(e) {
            e.preventDefault();
            $('.form-cars-search').toggle();
        });

        var $filters = $('.form-cars-search-filters .filters');

        // jeśli filtr jest zaznaczony to domyślnie ul jest rozwinięte
        $('ul > li input[type=checkbox]', $filters).each(function(e) {
            if($(this).is(':checked')) {
                var $ul = $(this).closest('ul');
                var $button = $ul.prev('button');

                $ul.removeClass('hidden-xs');
                $button.find('i.hidden-xs').removeClass('hidden-xs');
                $button.find('i.visible-xs-block').remove();
                $ul.show();
            }
        });

        $filters.children('button').click(function(e) {
            e.preventDefault();
            var $ul = $(this).next('ul');
            var iconClass;

            if($ul.is(':hidden')) {
                $ul.hide();
                $ul.removeClass('hidden-xs');
                iconClass = 'fa-chevron-up';
                $(this).find('i.hidden-xs').remove();
                $(this).find('i.visible-xs-block').removeClass('visible-xs-block');
            } else {
                iconClass = 'fa-chevron-down';
            }

            $ul.slideToggle();

            $(this).find('i').each(function(iteration, i){
                $(i).removeClass('fa-chevron-up').removeClass('fa-chevron-down');
                $(i).addClass(iconClass);
            });
        });

        $('.form-cars-search-filters .filters ul li input[type=checkbox]').change(function(e) {
            $container = $(this).closest('label');
            if($container.hasClass('selected')) {
                $container.removeClass('selected');
            } else {
                $container.addClass('selected');
            }
            $(this).closest('#form-cars-search').submit();
        });

        $filters.find('label.styled-checkbox').click(function(e) {
            $(this).find('input[type="checkbox"]').click();
        });

        $('.btn.check-price').click(checkPrice);

        $('[data-action="tooltip"]').tooltip({placement: 'top'});
    });

    $('.modal-terms').click(ModalTerms);
});